import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

import logo from "../assets/img/LogoFree.svg";
import "../assets/css/cs.css";

const meta = {
  title: "Terms & Conditions - Logy.AI",
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Terms() {
  const [menu, setMenu] = useState(true);
  const toggleMenu = () => {
    setMenu(!menu);
  };
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <section className="pt-6 bg-gray-50 overflow-hidden pb-6">
        <div className="container mx-auto px-4">
          <div className="mb-1">
            <div className="flex items-center justify-between px-6 py-3.5 bg-white border border-gray-100 rounded-full">
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto">
                    <Link className="inline-block" to="/">
                      <img
                        src={logo}
                        style={{
                          width: "100px",
                          transform: "translateY(3px) translateX(10px)",
                        }}
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto hidden lg:block">
                    <ul className="flex items-center justify-center ">
                      <li className="  ">
                        <Link
                          className=" inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700  "
                          to="/"
                        >
                          Home
                        </Link>
                      </li>
                      <li className="">
                        <Link
                          className=" inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700 "
                          to="/about"
                        >
                          About us
                        </Link>
                      </li>
                      <li className="">
                        <Link
                          className="inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/products"
                        >
                          Products
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/articles"
                        >
                          Articles
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/cases"
                        >
                          Case Studies
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto hidden lg:block">
                    <div className="flex flex-wrap -m-2">
                      <div className="w-full md:w-auto p-2" />
                      <div className="w-full md:w-auto p-2">
                        <Link
                          className="block w-full px-4 py-2.5 text-sm text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          to="/contact"
                        >
                          Get in Touch
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="w-auto lg:hidden">
                    <a className="inline-block" onClick={toggleMenu}>
                      <svg
                        className="navbar-burger text-blue-500"
                        width={45}
                        height={45}
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width={56}
                          height={56}
                          rx={28}
                          fill="currentColor"
                        />
                        <path
                          d="M37 32H19M37 24H19"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className=" navbar-menu fixed top-0 left-0 bottom-0 w-4/6 sm:max-w-xs z-50"
              hidden={menu}
            >
              <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-80" />
              <nav className="relative z-10 px-9 pt-8 bg-white h-full overflow-y-auto">
                <div className="flex flex-wrap justify-between h-full">
                  <div className="w-full">
                    <div className="flex items-center justify-between -m-2">
                      <div className="w-auto p-2">
                        <Link className="inline-block" to="/">
                          <img src={logo} style={{ width: "90px" }} alt="" />
                        </Link>
                      </div>
                      <div className="w-auto p-2">
                        <a
                          className="inline-block navbar-burger"
                          onClick={toggleMenu}
                        >
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 18L18 6M6 6L18 18"
                              stroke="#111827"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center py-8 w-full">
                    <ul>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/"
                        >
                          Home
                        </Link>
                      </li>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/about"
                        >
                          About us
                        </Link>
                      </li>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="products"
                        >
                          Products
                        </Link>
                      </li>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/articles"
                        >
                          Articles
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/cases"
                        >
                          Case Studies
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="flex flex-col justify-end w-full pb-8">
                    <div className="flex flex-wrap -m-2">
                      <div className="w-full p-2">
                        <Link
                          className="block w-full px-4 py-2.5 text-sm text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          to="/contact"
                        >
                          Get in Touch
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="flex flex-wrap justify-center -m-4">
            <div className="w-full md:flex-1 p-4"></div>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 pb-12">
        <div className="container mx-auto px-4 md:px-8 lg:px-16 max-w-6xl">
          <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Terms & Conditions
            </h1>

            <p className="text-gray-600 mb-8">
              <strong>Effective Date:</strong> January 1, 2024
            </p>

            <div className="space-y-8 text-gray-700">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="leading-relaxed">
                  By accessing or using the Logy.AI platform and services ("Services"), you agree to be bound by these
                  Terms and Conditions ("Terms"). If you do not agree to these Terms, you may not access or use our Services.
                  These Terms apply to all users, including healthcare professionals, institutions, and patients.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Use of Services</h2>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">2.1 Eligibility</h3>
                <p className="leading-relaxed mb-4">
                  You must be at least 18 years of age and have the legal authority to enter into these Terms. Healthcare
                  professionals must hold valid credentials and licenses to use our diagnostic tools.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-3">2.2 Permitted Use</h3>
                <p className="leading-relaxed mb-4">
                  Our AI-powered healthcare platform supports healthcare professionals and consumer screening programs
                  that we provide on behalf of clients. Consumer screening results are informational
                  and are not a medical diagnosis. You agree to use our Services only for lawful purposes and in
                  accordance with these Terms.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-3">2.3 Prohibited Activities</h3>
                <p className="leading-relaxed mb-2">You agree not to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Use the Services for any unlawful purpose or in violation of applicable regulations</li>
                  <li>Attempt to gain unauthorized access to our systems or networks</li>
                  <li>Interfere with or disrupt the Services or servers</li>
                  <li>Use the Services to transmit any harmful code or malware</li>
                  <li>Reverse engineer, decompile, or disassemble our AI algorithms</li>
                  <li>Use automated systems to access the Services without authorization</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Medical Disclaimer</h2>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-4">
                  <p className="leading-relaxed font-semibold text-gray-900 mb-2">
                    IMPORTANT: AI-Assisted Diagnostic Tool
                  </p>
                  <p className="leading-relaxed">
                    Logy.AI provides AI-powered screening and diagnostic assistance tools. Our Services are designed to
                    support, not replace, the relationship between individuals and healthcare professionals. Screening
                    results and AI-generated insights are informational. All diagnostic and treatment decisions should
                    be made by qualified healthcare professionals using their independent clinical judgment.
                  </p>
                </div>
                <p className="leading-relaxed">
                  We do not guarantee the accuracy, completeness, or reliability of AI-generated results. Healthcare professionals
                  are solely responsible for patient care decisions and should independently verify all AI-generated insights.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
                <p className="leading-relaxed mb-4">
                  All content, features, and functionality of the Services, including but not limited to AI algorithms,
                  software, text, graphics, logos, and images, are owned by Logy.AI or its licensors and are
                  protected by international copyright, trademark, and other intellectual property laws.
                </p>
                <p className="leading-relaxed">
                  You are granted a limited, non-exclusive, non-transferable license to access and use the Services for
                  their intended purpose. This license does not include any right to resell or commercial use of the Services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data and Privacy</h2>
                <p className="leading-relaxed mb-4">
                  Your use of our Services is governed by our Privacy Policy, which describes how personal data is
                  collected, used, disclosed, protected, and deleted. Any consent required by applicable law will be
                  requested separately and will not be inferred solely from acceptance of these Terms.
                </p>
                <p className="leading-relaxed">
                  Some services collect personal data directly from individuals on behalf of a client. The client is
                  responsible for providing required privacy notices and obtaining legally
                  valid consent, including parental or guardian consent for minors where required. Logy.AI may provide the
                  technical interface through which the client presents its notice, collects consent, records policy
                  acceptance, or obtains an acknowledgment. The client remains responsible
                  for the content and legal validity of that process. Healthcare professionals remain responsible for
                  obtaining appropriate patient consent before uploading patient data or medical images. All users and
                  clients must comply with applicable privacy and healthcare laws.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitation of Liability</h2>
                <p className="leading-relaxed mb-4">
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, LOGY.AI SHALL NOT BE LIABLE FOR ANY INDIRECT,
                  INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER
                  INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
                </p>
                <p className="leading-relaxed">
                  Our total liability to you for any claims arising from or related to these Terms or the Services shall
                  not exceed the amount you paid to us in the twelve (12) months preceding the claim.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Indemnification</h2>
                <p className="leading-relaxed">
                  You agree to indemnify, defend, and hold harmless Logy.AI, its officers, directors, employees,
                  and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable
                  attorney's fees, arising out of or in any way connected with your access to or use of the Services or your
                  violation of these Terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Regulatory Compliance</h2>
                <p className="leading-relaxed">
                  Our Services comply with applicable medical device regulations and healthcare standards. Healthcare
                  professionals are responsible for ensuring their use of our Services complies with local regulations
                  and professional standards of practice.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Modifications to Terms</h2>
                <p className="leading-relaxed">
                  We reserve the right to modify these Terms at any time. We will notify users of material changes by
                  posting the updated Terms on our website and updating the effective date. Your continued use of the
                  Services after such modifications constitutes acceptance of the updated Terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Termination</h2>
                <p className="leading-relaxed">
                  We may terminate or suspend your access to the Services immediately, without prior notice or liability,
                  for any reason, including if you breach these Terms. Upon termination, your right to use the Services
                  will cease immediately.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Governing Law</h2>
                <p className="leading-relaxed">
                  These Terms shall be governed by and construed in accordance with the laws of India,
                  without regard to its conflict of law provisions. Any legal action or proceeding arising
                  under these Terms shall be brought exclusively in the courts of Hyderabad, India.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
                <p className="leading-relaxed mb-4">
                  If you have any questions about these Terms & Conditions, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="font-semibold mb-2">Logy.AI</p>
                  <p className="mt-4">
                    Email: <a href="mailto:legal@logy.ai" className="text-blue-500 hover:text-blue-600">legal@logy.ai</a>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
